import styled, { keyframes } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const textShimmerKeyframes = keyframes(["0%{background-position:-300px 0;}100%{background-position:300px 0;}"]);
const StyledText = styled.div.withConfig({
  displayName: "DataPassingPanelHeaderInputSkeleton__StyledText",
  componentId: "sc-1b5ll3c-0"
})(["display:inline-block;border-radius:", ";width:100%;height:40px;background:linear-gradient( 106deg,", ",", ",", ",", " );animation:", " 15000ms linear 0s infinite normal forwards;"], ({
  theme
}) => theme.borderRadius[100], ({
  theme
}) => theme.color['fill-field-default'], ({
  theme
}) => theme.color['fill-tertiary-disabled'], ({
  theme
}) => theme.color['fill-field-default'], ({
  theme
}) => theme.color['fill-field-default'], textShimmerKeyframes);
const DataPassingPanelHeaderInputSkeleton = ({
  'data-test-id': dataTestId
}) => {
  return /*#__PURE__*/_jsx("div", {
    "data-test-id": dataTestId,
    children: /*#__PURE__*/_jsx(StyledText, {})
  });
};
export default DataPassingPanelHeaderInputSkeleton;